export const LOGIN = "login";
export const LOGOUT = "logout";
export const CHECK_AUTH = "checkAuth";
export const GET_ACCESS_TOKEN = "getAccessToken";
export const GET_API_TOKEN = "getApiToken";
export const REFRESH_TOKEN_TIMERS = "refreshTokenTimers";
export const GET_READ_ONLY_USERS = "getReadOnlyUsers";
export const GET_DOWNLOAD_USERS = "getDownloadUsers";
export const GET_USER_DATA = "getUserData";
export const CREATE_NEW_USER = "createNewUser";
export const ONBOARD_NEW_USER = "onboardNewUser";
export const ONBOARD_FETCH_USER = "onboardFetchUser";
export const UPDATE_USER = "updateUser";
export const DELETE_USER = "deleteUser";
export const DELETE_OTHER_USER = "deleteOtherUser";
export const GET_USER_PROFILE_PICTURE = "getUserProfilePicture";
export const GET_USER_BLUEPAGES_PICTURE = "getUserBluepagesPicture";
export const GET_USER_BLUEPAGES_PICTURE_RAW = "getUserBluepagesPictureRaw";
export const UPDATE_USER_FROM_BLUEPAGES = "updateUserFromBluepages";
export const DELETE_USER_EXPERIENCE = "deleteUserExperience";
export const UPLOAD_RESOURCES = "uploadResources";
export const UPLOAD_RESOURCES_END_DATES = "uploadResourcesEndDates";

export const GET_PROGRAMME = "getProgrammes";
export const GET_PROGRAMME_DETAIL = "getProgrammeDetail";

export const GET_COMMENT_TYPE = "getCommentType";

export const GET_SECTOR = "getSector";
export const CREATE_SECTOR = "createSector";
export const UPDATE_SECTOR = "updateSector";
export const DELETE_SECTOR = "deleteSector";

export const GET_ACCOUNT_GROUP = "getAccountGroups";
export const CREATE_ACCOUNT_GROUP = "createAccountGroups";
export const UPDATE_ACCOUNT_GROUP = "updateAccountGroups";
export const DELETE_ACCOUNT_GROUP = "deleteAccountGroups";

export const GET_RESOURCE_GROUP = "getResourceGroup";
export const GET_RESOURCE_GROUP_DETAIL = "getResourceGroupDetail";
export const CREATE_RESOURCE_GROUP = "createResourceGroup";
export const UPDATE_RESOURCE_GROUP = "updateResourceGroup";
export const DELETE_RESOURCE_GROUP = "deleteResourceGroup";

export const GET_ACCOUNT = "getAccount";
export const CREATE_ACCOUNT = "createAccount";
export const UPDATE_ACCOUNT = "updateAccount";
export const DELETE_ACCOUNT = "deleteAccount";

export const GET_PROJECT = "getProjects";
export const GET_DOWNLOAD_PROJECTS = "getDownloadProjects";
export const GET_PROJECT_BY_ID = "getProjectDetail";
export const GET_PROJECT_BY_NAME = "getProjectByName";
export const CREATE_PROJECT = "createProject";
export const UPDATE_PROJECT = "updateProject";
export const DELETE_SOFT = "deleteSoft";
export const UPDATE_SUB_PROJECT = "updateSubProject";

export const GET_PROJECT_OPEN_SEATS = "getProjectOpenSeats";
export const GET_PROJECT_RESOURCES = "getProjectResources";
export const CREATE_PROJECT_RESOURCES = "createProjectResources";
export const UPDATE_PROJECT_RESOURCES = "updateProjectResources";

export const GET_SKILL = "Skill";
export const CREATE_SKILL = "createSkill";
export const UPDATE_SKILL = "updateSkill";
export const DELETE_SKILL = "deleteSkill";
export const GET_TECH_SKILL = "TechSkill";
export const GET_SOFT_SKILL = "SoftSkill";

export const GET_ROLE = "getRole";

export const GET_CV_REVIEWER_OPEN_SEATS = "getCVReviewerOpenSeats";

export const GET_USER_ROLE = "getUserRoles";
export const CREATE_USER_ROLE = "createUserRole";
export const UPDATE_USER_ROLE = "updateUserRole";
export const DELETE_USER_ROLE = "deleteUserRole";

export const GET_FILES = "getFiles";
export const CREATE_FILES = "createFiles";
export const UPDATE_FILES = "updateFiles";
export const DELETE_FILES = "deleteFiles";

export const GET_SUPPORT = "getSupport";
export const GET_SUPPORT_DETAIL = "getSupportDetail";
export const CREATE_SUPPORT_FEEDBACK = "createSupportFeedback";
export const CREATE_SUPPORT_BUG = "createSupportBug";
export const CREATE_SUPPORT_DATA_ACCESS = "createSupportDataAccess";
export const UPLOAD_BUG_IMAGE = "uploadBugImage";
export const UPDATE_SUPPORT = "updateSupport";
export const DELETE_SUPPORT = "deleteSupport";
export const GET_SUPPORT_TYPE = "getSupportTypes";

export const GET_BAND = "getBands";
export const GET_SEAT_STATUS = "getSeatStatus";
export const GET_RESOURCE_TYPE = "getResourceType";

export const CREATE_RESOURCE = "createResources";

export const GET_CANDIDATE = "getCandidates";
export const GET_CANDIDATE_DATA = "getCandidateData";
export const GET_CANDIDATE_DETAIL = "getCandidateDetail";
export const GET_CANDIDATE_BY_SERIAL = "getCandidateBySerial";
export const CREATE_CANDIDATE_COMMENT = "createCandidateComment";
export const GET_CANDIDATE_TO_ADD = "getCandidateToAdd";
export const UPDATE_CANDIDATE = "updateCandidate";
export const CREATE_CANDIDATE = "createCandidate";
export const UPDATE_COMMENTS = "updateComments";
export const DOWNLOAD_CANDIDATE = "downloadCandidate";

export const GET_COMMENTS_BY_CANDIDATE = "getCommentByCandidate";

export const GET_JOB_ROLE_SPECIALTIES = "getJobRoleSpecialties";
export const UPDATE_JOB_ROLE_SPECIALTIES = "updateJobRoleSpecialties";
export const DELETE_JOB_ROLE_SPECIALTIES = "deleteJobRoleSpecialties";
export const CREATE_JOB_ROLE_SPECIALTIES = "createJobRoleSpecialties";

export const GET_ARCHIVES = "getArchives";

export const GET_OPEN_SEAT = "getOpenSeat";
export const GET_DOWNLOAD_OPEN_SEATS = "getDownloadOpenSeats";
export const GET_OPEN_SEAT_BY_ID = "getOpenSeatById";
export const GET_OPEN_SEAT_STATUS_HISTORY = "getOpenSeatStatusHistory";
export const UPDATE_OPEN_SEAT = "updateOpenSeat";
export const DELETE_OPEN_SEAT = "deleteOpenSeat";
export const CREATE_OPEN_SEAT = "createOpenSeat";
export const CREATE_OPEN_SEAT_CANDIDATE = "createOpenSeatCandidate";
export const UPDATE_BATCH_OPEN_SEAT_STATUS = "updateBatchOpenSeatStatus";

export const GET_TSC = "getTsc";
export const GET_DOWNLOAD_TSC = "getDownloadTsc";
export const GET_TSC_BY_ID = "getTscById";
export const GET_TSC_BY_SERIAL = "getTscBySerial";
export const UPDATE_TSC = "updateTsc";
export const DELETE_TSC = "deleteTsc";
export const CREATE_TSC = "createTsc";

export const GET_AGENCY = "getAgency";
export const UPDATE_AGENCY = "updateAgency";
export const DELETE_AGENCY = "deleteAgency";
export const CREATE_AGENCY = "createAgency";

export const GET_ACCESS_LEVEL = "getAccessLevel";
export const UPDATE_ACCESS_LEVEL = "updateAccessLevel";
export const DELETE_ACCESS_LEVEL = "deleteAccessLevel";
export const CREATE_ACCESS_LEVEL = "createAccessLevel";

export const CREATE_USER_ACCESS_LEVEL = "createUserAccessLevel";
export const UPDATE_USER_ACCESS_LEVEL = "updateUserAccessLevel";

export const GET_CV = "getCV";
export const CREATE_CV = "createCV";
export const DELETE_CV = "deleteCV";
export const UPDATE_CV = "updateCV";

export const GET_STATUSES = "getStatuses";
export const downloadCV = "downloadCV";
export const GET_SEARCH_COMPONENTS = "getSearchComponents";
export const GET_PERSON_BY_ID = "getPersonById";
export const GET_OPEN_SEATS_BY_ID = "getOpenSeatsById";
export const GET_OPEN_SEATS_BY_PMP_ID = "getOpenSeatsByPMPId";

export const CREATE_SEARCH_HISTORY = "createSearchHistory";
export const GET_SEARCH_HISTORY = "getSearchHistory";
export const DELETE_SEARCH_HISTORY = "deleteSearchHistory";
export const UPDATE_SEARCH_HISTORY = "updateSearchHistory";

export const GET_NOTIFICATIONS = "getNotifications";

export const GET_SECTORS = "getSectors";
export const GET_INDUSTRY = "getIndustry";

export const GET_CURRENCY = "getCurrency";
export const GET_OPEN_SEAT_PERSON_STATUS = "getOpenSeatPersonStatus";

export const GET_PERSON = "getPerson";
export const GET_CANDIDATE_PERSON = "getCandidatePerson";
export const GET_RESOURCE_PERSON = "getResourcePerson";
export const DELETE_PERSON = "deletePerson";

export const GET_OPEN_SEAT_CANDIDATE = "getOpenSeatCandidate";
export const GET_OS_CANDIDATE_BY_SERIAL = "getOpenSeatCandidateBySerial";

export const GET_EMPLOYEE_TYPE = "getEmployeeType";

export const GET_ATTACHMENTS_BY_ID = "getAttachmentById";
export const CREATE_ATTACHMENT = "createAttachment";
export const UPDATE_ATTACHMENT = "updateAttachment";
export const UPLOAD_ATTACHMENT = "uploadAttachment";

export const GET_EMAIL_TEMPLATE = "getEmailTemplate";
export const GET_EMAIL_TEMPLATE_BY_ID = "getEmailTemplateById";
export const CREATE_EMAIL_TEMPLATE = "createEmailTemplate";
export const UPDATE_EMAIL_TEMPLATE = "updateEmailTemplate";
export const DELETE_EMAIL_TEMPLATE = "deleteEmailTemplate";

export const GET_DOCUMENT_TYPE = "getDocumentType";
export const GET_LOCATION = "getLocation";

export const GET_BADGE = "getBadge";
export const CREATE_BADGE = "createBadge";
export const UPDATE_BADGE = "updateBadge";
export const DELETE_BADGE = "deleteBadge";
export const GET_USER_BADGE = "getUserBadge";
// export const UPDATE_USER_BADGE = "updateUserBadges";
export const SYNC_USER_BADGES = "syncUserBadges";

export const CREATE_BAND = "createBand";
export const UPDATE_BAND = "updateBand";
export const DELETE_BAND = "deleteBand";

export const GET_DEGREE_LEVEL = "getDegreeLevel";
export const CREATE_DEGREE_LEVEL = "createDegreeLevel";
export const UPDATE_DEGREE_LEVEL = "updateDegreeLevel";
export const DELETE_DEGREE_LEVEL = "deleteDegreeLevel";
export const GET_EXPERIENCE_LEVEL = "getExperienceLevel";
export const CREATE_EXPERIENCE_LEVEL = "createExperienceLevel";
export const UPDATE_EXPERIENCE_LEVEL = "updateExperienceLevel";
export const DELETE_EXPERIENCE_LEVEL = "deleteExperienceLevel";
export const CREATE_RESOURCE_USER = "createResourceUser";

export const GET_GROWTH_PLATFORM = "getGrowthPlatform";
export const CREATE_GROWTH_PLATFORM = "createGrowthPlatform";
export const UPDATE_GROWTH_PLATFORM = "updateGrowthPlatform";
export const DELETE_GROWTH_PLATFORM = "deleteGrowthPlatform";

export const CREATE_LOCATION = "createLocation";
export const UPDATE_LOCATION = "updateLocation";
export const DELETE_LOCATION = "deleteLocation";
export const GET_PRACTICE = "getPractice";
export const CREATE_PRACTICE = "createPractice";
export const UPDATE_PRACTICE = "updatePractice";
export const DELETE_PRACTICE = "deletePractice";
export const GET_PRONOUN = "getPronoun";
export const CREATE_PRONOUN = "createPronoun";
export const UPDATE_PRONOUN = "updatePronoun";
export const DELETE_PRONOUN = "deletePronoun";

export const CREATE_ROLE = "createRole";
export const UPDATE_ROLE = "updateRole";
export const DELETE_ROLE = "deleteRole";
export const GET_PERMISSION = "getPermission";
export const CREATE_PERMISSION = "createPermission";
export const UPDATE_PERMISSION = "updatePermission";
export const DELETE_PERMISSION = "deletePermission";

export const GET_ROLE_PERMISSION = "getRolePermission";
export const CREATE_ROLE_PERMISSION = "createRolePermission";
export const UPDATE_ROLE_PERMISSION = "updateRolePermission";
export const DELETE_ROLE_PERMISSION = "deleteRolePermission";

export const GET_SEARCH_COMPONENT = "getSearchComponent";
export const GET_NOTIFICATION = "getNotification";
export const GET_OPEN_SEAT_TYPE = "getOpenSeatType";
export const GET_OPEN_SEAT_STATUS = "getOpenSeatStatus";
export const GET_OPEN_SEAT_PROGRESS_STATUS = "getOpenSeatProgressStatus";
export const GET_CANDIDATE_STATUS = "getCandidateStatus";

export const UPDATE_OPEN_SEAT_CANDIDATE = "updateOpenSeatUsers";
export const GET_CANDIDATES_BY_OPEN_SEAT_ID = "getCandidatesByOpenSeatId";
export const GET_SUITABLE_CANDIDATES = "getSuitableCandidates";
export const GET_CANDIDATE_USER = "getCandidateUser";
export const GET_DOWNLOAD_CANDIDATES = "getDownloadCandidates";

export const GET_RESOURCE_USER = "getResourceUser";
export const GET_DOWNLOAD_RESOURCES = "getDownloadResources";
export const GET_RESOURCE_SERIAL = "getResourceSerial";
export const GET_RESOURCES = "getResources";
export const GET_RESOURCE_BY_ID = "getResources";
export const CREATE_ONBOARDED_RESOURCE = "createOnboardedResource";
export const UPDATE_OFFBOARD_RESOURCE = "updateOffboardResource";
export const UPDATE_RESOURCE_CLIENT = "updateResourceClient";
export const GET_RESOURCE_PARAMETER = "getResourceParameter";
export const GET_RESOURCE_PARAMETER_DATA = "getResourceParameterData";
export const GET_RESOURCE_FOR_OPEN_SEAT = "getResourceForOpenSeat";
export const CREATE_RESOURCE_PARAMETER_DATA = "createTableMetadataeterData";
export const UPDATE_RESOURCE_PARAMETER_DATA = "updateTableMetadataeterData";
export const DELETE_RESOURCE_PARAMETER_DATA = "deleteResourceParameterData";

export const GET_TSC_SNAPSHOT = "getTscSnapshot";

export const GET_USER_INVOICE = "getUserInvoice";
export const GET_INVOICES_BY_PO = "getInvoicesByPo";
export const UPDATE_USER_INVOICE = "updateUserInvoice";
export const CREATE_USER_INVOICE = "createUserInvoice";
export const DELETE_USER_INVOICE = "deleteUserInvoice";

export const GET_USER_PURCHASE_ORDERS = "getUserPurchaseOrders";
export const UPDATE_USER_PURCHASE_ORDERS = "updateUserPurchaseOrders";
export const CREATE_USER_PURCHASE_ORDERS = "createUserPurchaseOrders";
export const DELETE_USER_PURCHASE_ORDERS = "deleteUserPurchaseOrders";

export const GET_USER_PROJECT_BOARD = "getUserProjectBoard";
export const CREATE_USER_PROJECT_BOARD = "createUserProjectBoard";
export const UPDATE_USER_PROJECT_BOARD = "updateUserProjectBoard";

export const GET_PERMISSION_GROUPS = "getPermissionGroups";
export const GET_PERMISSION_GROUPS_DETAIL = "getPermissionGroupsDetail";
export const UPDATE_PERMISSION_GROUPS = "updatePermissionGroups";
export const CREATE_PERMISSION_GROUPS = "createPermissionGroups";

export const GET_REPORT = "getReport";

export const GET_USER_PREFERENCES = "getUserPreferences";
export const UPDATE_USER_PREFERENCES = "updateUserPreferences";
export const CREATE_USER_PREFERENCES = "createUserPreferences";

export const SEND_EMAIL = "sendEmail";

export const GET_EMAIL_LOGS = "getEmailLogs";
export const GET_EMAIL_LOG_DETAIL = "getEmailLogDetail";
export const GET_EMAIL_LOGS_BY_SEAT = "getEmailLogsBySeat";
export const CREATE_EMAIL_LOG = "createEmailLog";

export const GET_BOARDING_STATUSES = "getOnboardingStatuses";
export const GET_OFFBOARDING_TYPES = "getOffboardingTypes";
export const GET_SLACK_STATUSES = "getSlackStatuses";

//
// Insights Actions
//
export const GET_OPEN_SEATS_BY_JOB_ROLE = "getOpenSeatsByJobRole";
export const GET_AVAILABLE_RESOURCES = "getAvailableResources";
export const GET_ACTIVE_USERS = "getActiveUsers";
export const GET_OPEN_SEATS_BY_ACCOUNT = "getOpenSeatsByAccount";
export const GET_RESOURCES_OVER_TIME = "getResourcesOverTime";
export const GET_OPEN_SEATS_BY_PROJECT = "getOpenSeatsByProject";
export const GET_ACTIVE_PROJECTS = "getActiveProjects";
export const GET_AVAILABLE_PROJECTS = "getAvailableProjects";
export const GET_ACTIVE_OPEN_SEATS = "getActiveOpenSeats";
export const GET_AVAILABLE_OPEN_SEATS = "getAvailableOpenSeats";
export const GET_OPEN_SEATS_OVER_TIME = "getOpenSeatsOverTime";
export const GET_PERSON_ACCOUNT_CHART = "getPersonAccountChart";
export const GET_RESOURCES_BY_BAND = "getPersonGroupBandChart";
export const GET_PERSON_PRACTICE_CHART = "getPersonPracticeChart";
